import React, { ReactNode } from 'react';
import { CorporationConfiguration } from '../util/Corporations';
import getTextColor from '../util/Color';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: ReactNode;
    corporation: CorporationConfiguration;
}

const Button: React.FC<ButtonProps> = ({
    children,
    corporation,
    onClick,
    type,
    disabled,
}) => {
    // A corp that hasn't configured a real accent color just reuses its
    // themeColor for secondaryColor too — fall back to a neutral white/black
    // button instead of a same-on-same-color button that reads as flat.
    const hasAccentColor =
        corporation.secondaryColor &&
        corporation.secondaryColor.toLowerCase() !==
            corporation.appConfig.journey.themeColor?.toLowerCase();
    const backgroundColor = hasAccentColor ? corporation.secondaryColor : '#fff';
    const color = hasAccentColor
        ? getTextColor(corporation.secondaryColor, '#fff')
        : '#000';

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className='font-semibold rounded-lg disabled:opacity-50 disabled:cursor-not-allowed'
            style={{
                backgroundColor,
                color,
            }}
        >
            {children}
        </button>
    );
};

export default Button;
